import * as tslib_1 from "tslib";
import { Base } from '../base-component';
// import Slider from '../slider/slider.component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import './article-page-video-carousel.component.scss';
var ArticlePageVideoCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePageVideoCarousel, _super);
    function ArticlePageVideoCarousel(element) {
        return _super.call(this, element) || this;
    }
    ArticlePageVideoCarousel.prototype.init = function () {
        var _this = this;
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderItems = this.element.querySelectorAll('.video-carousel-item');
        this.windowWidth = document.documentElement.clientWidth;
        this.sliderConfig = {
            preventClicks: false,
            preventClicksPropagation: false,
            slidesPerView: 1,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 2.4,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        this.slider = new Swiper(this.sliderContainer, this.sliderConfig);
        // this.slider = Slider.init(this.sliderContainer, this.sliderConfig);
        this.slider.on('slideChange', function (event) {
            _this.slideChangeVideoRefresh();
        });
    };
    ArticlePageVideoCarousel.prototype.bindEvents = function () { };
    ArticlePageVideoCarousel.prototype.slideChangeVideoRefresh = function () {
        var _this = this;
        // slides
        var slides = this.element.querySelectorAll('.article-page-video-carousel-item');
        // foreach
        slides.forEach(function (slide) {
            // vars
            var container = slide.querySelector('.article-page-video-carousel-item__container');
            var player = slide.querySelector('.article-page-video-carousel-item__player');
            var playercontent = slide.querySelector('.article-page-video-carousel-item__playercontent');
            // embed removal
            if (playercontent.querySelector('#video__external')) {
                var embed = playercontent.querySelector('#video__external');
                embed.remove();
            }
            // no picture
            if (!slide.querySelector('picture')) {
                container.classList.add('article-page-video-carousel-item__container--playing');
                if (slide.querySelector('.article-page-video-carousel-item__player--close-button')) {
                    var closeButton = slide.querySelector('.article-page-video-carousel-item__player--close-button');
                    closeButton.classList.add('d-none');
                }
                if (player.hasAttribute('data-youtube-id')) {
                    var getVideo = player.getAttribute('data-youtube-id');
                    _this.createIframePlayerInit(getVideo, playercontent);
                    _this.analyticsService.dtmVideoTrackerAutoSpot();
                }
                else if (player.hasAttribute('data-video-file')) {
                    var getVideo = player.getAttribute('data-video-file');
                    _this.createHTML5PlayerInit(getVideo, playercontent);
                }
            }
            else {
                container.classList.remove('article-page-video-carousel-item__container--playing');
            }
        });
    };
    ArticlePageVideoCarousel.prototype.createHTML5PlayerInit = function (url, container) {
        if (container === void 0) { container = undefined; }
        if (container) {
            var externalUrl = url;
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.setAttribute('allowfullscreen', 'true');
            createIframe.classList.add('video__iframe');
            container.appendChild(createIframe);
        }
    };
    ArticlePageVideoCarousel.prototype.createIframePlayerInit = function (url, container) {
        if (container === void 0) { container = undefined; }
        if (container) {
            var externalUrl = 'https://www.youtube.com/embed/';
            externalUrl += url;
            externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.setAttribute('allowfullscreen', 'true');
            createIframe.classList.add('video__iframe');
            container.appendChild(createIframe);
        }
    };
    return ArticlePageVideoCarousel;
}(Base));
export { ArticlePageVideoCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/article-page-video-carousel/article-page-video-carousel.component.ts
// module id = 107
// module chunks = 0